import { ScrollView, View } from 'react-native';
import { Button, IconButton, Text, useTheme } from "react-native-paper";
import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import * as XLSX from "xlsx"
import Preferance from '../constants/Preferances';

import { MaterialIcons } from '@expo/vector-icons';
import Global from '../constants/global';
import { useSelector } from 'react-redux';

const pageStyle = `

  @media all {
    .pagebreak {
      display: none;
      page-break-after: always;
    }
  }

  @media print {
    .pagebreak {
      page-break-after: always;
    }
  }
`;
export default function PrintTarij({ navigation, route }) {
    const pref = useContext(Preferance)
    const S = useSelector(s => s.list.Tarij[route.params.classId + route.params.year + route.params.examName])
    //console.log("the s is", S)
    const ref = useRef()
    const t = useTheme()
    return <View>
        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", alignSelf: "flex-start" }}>
            <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => <div style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: t.colors.primary, color: t.colors.onPrimary, padding: 5, borderRadius: 5, paddingRight: 10 }}><MaterialIcons style={{ marginLeft: 5, marginRight: 5 }} name="print" color={t.colors.onPrimary} />Print</div>}
                content={() => ref.current}
            />
            {pref?.current.supervisor == true && <Button onPress={() => {
                try {
                    const workbook = XLSX.utils.book_new();
                    const headers = ["રોલ", "GR", "વિદ્યાર્થી નું નામ"]
                    value.subjects.map(s => headers.push(s.name))
                    headers.push("પરિણામ")
                    headers.push("મેળવેલ ગુણ")
                    headers.push("Rank")
                    const l2: [] = []
                    value?.sheet?.filter(e => e?.totalling !== true)?.map(s => {
                        const me = { "roll": s.student["class" + value.year]?.roll, gr: s.student["class" + value.year]?.gr, name: s.student.name + (Global.isLeft(s.student, value.year) ? "(Left)" : "") }
                        value.subjects.map(e => {
                            const vv = s.subject.find(f => f?.subject_id == e.id)
                            if (vv) {
                                me[e.name] = Global.getValue(vv, "Ab")
                            } else {
                                me[e.name] = ""
                            }
                        }
                        )
                        me.status = Global.isLeft(s.student, value.year) ? "Left" : Global.getResultStatus(s.examObject.status)
                        me.marks = s.examObject.subjectMarks
                        me.rank = s.examObject.rank ? s.examObject.rank : ""
                        l2.push(me)
                    })
                    const worksheet = XLSX.utils.json_to_sheet(l2)
                    //console.log(l2)
                    XLSX.utils.book_append_sheet(workbook, worksheet, "SummarySheet");
                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
                    XLSX.writeFile(workbook, "SummarySheet" + value.class.name + (value.class.div ? " " + value.class.div : "") + ".xlsx");
                } catch (e) {
                    //console.log("me the e", e)
                    alert("error")
                }
            }}>Export</Button>}
        </View>
        <View>
            <div ref={ref} style={{ display: "block", width: "98%", marginLeft: 10, boxSizing: "border-box" }}>

                <div style={{ marginLeft: 100, display: "block", marginRight: 30 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Text variant="displaySmall" style={{ fontWeight: "bold", textAlign: "center", flex: 1, marginTop: 20, }}>{"શ્રી ઠક્કરબાપા વિદ્યામંદિર"}</Text>
                        <Text style={{ flex: 1, padding: 10, textAlign: "center" }} variant="titleLarge">પરિણામ પત્રક - {S?.examName}</Text>
                        <View style={{ flexDirection: "row" }}>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", borderWidth: 1 }}>
                                <Text variant="titleLarge" style={{ fontWeight: "bold" }}>{S?.examName}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", borderWidth: 1, }}>
                                <Text variant="titleLarge" style={{ fontWeight: "bold" }}>{S?.className} {S?.div}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", borderWidth: 1 }}>
                                <Text variant="titleLarge" style={{ fontWeight: "bold" }}>વર્ષ {route?.params?.year}</Text>
                            </View>
                        </View>
                        <View style={{ padding: 2, borderWidth: 2, marginTop: 20 }}>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid", fontWeight: "bold" }} variant="titleMedium">વિદ્યાર્થીઓની કુલ સંખ્યા</Text>
                                <Text style={{ flex: 1, textAlign: "center" , fontWeight: "bold"}} variant="titleLarge">{(S?.totalStudentCount)}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid", fontWeight: "bold" }} variant="titleMedium">પરીક્ષામાં બેઠેલા વિદ્યાર્થીઓની સંખ્યા </Text>
                                <Text style={{ flex: 1, textAlign: "center" , fontWeight: "bold"}} variant="titleLarge">{S?.examSeatCount}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid", fontWeight: "bold" }} variant="titleMedium">ઉત્તીર્ણ થનાર વિદ્યાર્થીઓની સંખ્યા </Text>
                                <Text style={{ flex: 1, textAlign: "center" , fontWeight: "bold"}} variant="titleLarge">{S?.passCount}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid", fontWeight: "bold" }} variant="titleMedium">નાપાસ થનાર વિદ્યાર્થીઓની સંખ્યા </Text>
                                <Text style={{ flex: 1, textAlign: "center" , fontWeight: "bold"}} variant="titleLarge">{S?.failCount}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid", fontWeight: "bold" }} variant="titleMedium">વિદ્યાર્થીઓની કુલ સંખ્યા પર પરિણામના ટકા </Text>
                                <Text style={{ flex: 1, textAlign: "center" , fontWeight: "bold"}} variant="titleLarge">{S?.percentResult}</Text>
                            </View>

                            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid", fontWeight: "bold" }} variant="titleMedium">પરીક્ષામાં બેઠેલ વિદ્યાર્થીઓની સંખ્યા પર પરિણામના ટકા</Text>
                                <Text style={{ flex: 1, textAlign: "center" , fontWeight: "bold"}} variant="titleLarge">{S?.settingPercentResult}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 30, flex: 1, alignSelf: "stretch" }}>
                            <View style={{ alignItems: "center", justifyContent: "center", flex: 1, alignSelf: "stretch" }}>
                                <View style={{ flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid", backgroundColor: "#DCDCDC" }}>
                                    <Text style={{ flex: 150, flexShrink: 0, textAlign: "center", borderRightWidth: 1 , fontWeight: "bold"}}>વિષય </Text>
                                    <Text style={{ flex: 150, textAlign: "center", borderRightWidth: 1 , fontWeight: "bold"}}>વિષયશિક્ષક</Text>
                                    <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>પરીક્ષામાં બેઠેલ સંખ્યા</Text>
                                    <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>ઉતીર્ણ સંખ્યા</Text>
                                    <Text style={{ flex: 50, textAlign: "center", fontWeight: "bold" }}>ટકાવારી</Text>
                                </View>
                                <View style={{ alignSelf: "stretch", flex: 1 }}>
                                    {
                                        S?.subjectResult.map(s => {
                                            const rx = Math.round((s.pass * 100) / s.attend)
                                            let rs
                                            if (isNaN(rx)) {
                                                rs = ""
                                            } else {
                                                rs = rx
                                            }
                                            return <View style={{ borderWidth: 1, flexDirection: "row", alignSelf: "stretch", borderStyle: "solid" }}>
                                                <Text style={{ flexShrink: 0, flex: 150, borderRightWidth: 1, fontWeight: "bold" }}>{s.subName}</Text>
                                                <Text style={{ flex: 150, borderRightWidth: 1, fontWeight: "bold" }}>{s?.teacherName}</Text>
                                                <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>{s.attend}</Text>
                                                <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>{s.pass}</Text>
                                                <Text style={{ flex: 50, textAlign: "center", fontWeight: "bold" }}>{s?.result}</Text>
                                            </View>
                                        })
                                    }
                                </View>
                            </View>
                        </View>
                        <View style={{ alignItems: "center", justifyContent: "center", marginTop: 30 }}>
                            <View style={{ flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid", backgroundColor: "#DCDCDC" }}>
                                <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>ક્રમાંક નં</Text>
                                <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1 , fontWeight: "bold"}}>રોલ નં</Text>
                                <Text style={{ flex: 300, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>વિદ્યાર્થીનું નામ</Text>
                                <Text style={{ flex: 80, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>મેળવેલ ગુણ</Text>
                                <Text style={{ flex: 80, textAlign: "center", fontWeight: "bold" }}>ટકાવારી (%)</Text>
                            </View>
                            <View style={{ alignSelf: "stretch", flex: 1 }}>
                                {
                                    S?.rankList.map((s) => {
                                        return <View style={{ borderWidth: 1, flexDirection: "row", alignSelf: "stretch", borderStyle: "solid" }}>
                                            <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>{s.rank}</Text>
                                            <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>{s?.roll}</Text>
                                            <Text style={{ flex: 300, borderRightWidth: 1, fontWeight: "bold" }}>{s?.name}</Text>
                                            <Text style={{ flex: 80, textAlign: "center", borderRightWidth: 1, fontWeight: "bold" }}>{s?.marks}</Text>
                                            <Text style={{ flex: 80, textAlign: "center", fontWeight: "bold" }}>{s?.pc} %</Text>
                                        </View>
                                    })
                                }
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 70 }}>
                            <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                <Text variant="titleLarge" style={{ textAlign: "center" }}>  વર્ગ શિક્ષક  </Text>
                            </View>
                            <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                <Text variant="titleLarge" style={{ textAlign: "center" }}>  તારીખ  </Text>
                            </View>
                            <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                <Text variant="titleLarge" style={{ textAlign: "center" }}>  આચાર્ય  </Text>
                            </View>
                        </View>
                    </div>
                    <div className="pagebreak" />
                </div>


            </div>
        </View >
    </View>
}